import axios from "../axios-afterschoolmusic";

export function formatCurrency(value) {
	const result = value.toLocaleString("en-US", {
		style: 'currency',
		currency: 'USD',
		currencyDisplay: 'symbol',
		useGrouping: true,
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
	return result;
}

export function stripHtml(value) {
	const result = value.replace(/<style[^>]*>.*<\/style>/gm, '').replace(/<script[^>]*>.*<\/script>/gm, '').replace(/<[^>]+>/gm, '').replace(/([\r\n]+ +)+/gm, '');
	return result;
}

export function getTextBlocks() {
	return new Promise(function (resolve, reject) {
		axios.get('/TextBlock.json')
		.then(response => {
			const serviceTextBlocks = [];
			const textBlockDataKeys = Object.keys(response.data);
			if(textBlockDataKeys && textBlockDataKeys.length > 0) {
				for (let i = 0; i < textBlockDataKeys.length; i++) {
					serviceTextBlocks.push({
						...response.data[textBlockDataKeys[i]],
						id: textBlockDataKeys[i]
					});
				}
			}
			resolve(serviceTextBlocks);
		}).catch(error => {
			reject([]);
		});
	});
}

export function getBanners() {
	return new Promise(function (resolve, reject) {
		axios.get('/Banner.json')
		.then(response => {

			const banners = [];
			const bannerDataKeys = Object.keys(response.data);
			for (let i = 0; i < bannerDataKeys.length; i++) {
				if(response.data[bannerDataKeys[i]] && response.data[bannerDataKeys[i]].Active) {
					banners.push({
						...response.data[bannerDataKeys[i]],
						id: bannerDataKeys[i]
					});
				}
			}

			resolve(banners);
		}).catch(error => {
			reject([]);
		});
	});
}

export function getCalendars() {
	return new Promise(function (resolve, reject) {
		axios.get('/Calendar.json')
		.then(response => {
			const calendars = [];
			const calendarDataKeys = Object.keys(response.data);
			for (let i = 0; i < calendarDataKeys.length; i++) {
				calendars.push({
					...response.data[calendarDataKeys[i]],
					id: calendarDataKeys[i]
				});
			}

			resolve(calendars);
		}).catch(error => {
			reject([]);
		});
	});
}

export function getStaff() {
	return new Promise(function (resolve, reject) {
		axios.get('/Staff.json')
		.then(response => {
			const staffData = [];
			const staffDataKeys = Object.keys(response.data);
			if(staffDataKeys && staffDataKeys.length > 0) {
				for (let i = 0; i < staffDataKeys.length; i++) {
					staffData.push({
						...response.data[staffDataKeys[i]],
						id: staffDataKeys[i]
					});
				}
			}
			resolve(staffData);
		}).catch(error => {
			reject([]);
		});

	});
}

export function getLocations() {
	return new Promise(function (resolve, reject) {
		axios.get('/Location.json')
		.then(response => {
			const locations = [];
			const locationDataKeys = Object.keys(response.data);
			if(locationDataKeys && locationDataKeys.length > 0) {

				for (let i = 0; i < locationDataKeys.length; i++) {
					locations.push({
						...response.data[locationDataKeys[i]],
						id: locationDataKeys[i]
					});
				}
			}
			resolve(locations);
		}).catch(error => {
			reject([]);
		});
	});
}

export function getPages() {
	return new Promise(function (resolve, reject) {
		axios.get('/LocationPage.json')
		.then(response => {
			const routeData = [];
			const locationPageDataKeys = Object.keys(response.data);
			if(locationPageDataKeys && locationPageDataKeys.length > 0) {
				for (let i = 0; i < locationPageDataKeys.length; i++) {
					const locationPage = response.data[locationPageDataKeys[i]];
					let routeTextBlocks = locationPage.TextBlocks;
					if(routeTextBlocks == null) {
						routeTextBlocks = [];
					}

					const currentRoute = {
						id: locationPageDataKeys[i],
						menuText: locationPage.MenuText,
						component: locationPage.Component,
						url: locationPage.PageUrl,
						locationId: locationPage.LocationId,
						pageTitle: locationPage.PageTitle,
						pageDescription: locationPage.PageDescription,
						textBlocks: routeTextBlocks,
						subMenuItems: locationPage.SubmenuItems,
						showInMenu: locationPage.ShowInMenu
					};

					routeData.push(currentRoute);
				}
			}
			resolve(routeData);
		}).catch(error => {
			reject([]);
		});
	});
}
